
import React from "react";
import classNames from "classnames";
import PropTypes from 'prop-types';

const Toggle = ({ onClick, isOn, enabled = true }) => {

    const buttonState = classNames(`relative inline-flex flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors ease-in-out duration-200 h-9 w-[72px] disabled:cursor-not-allowed`, { "bg-gray-200": !isOn }, { "bg-blue-text": isOn });
    const outerIcon = classNames(`pointer-events-none relative inline-block h-8 w-8 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`, { "translate-x-0": !isOn }, { "translate-x-9": isOn });

    const icons = `absolute inset-0 flex h-full w-full items-center justify-center transition-opacity`;
    const xIcon = classNames(icons, { "opacity-100 ease-in duration-200": !isOn }, { "opacity-0   ease-out  duration-100": isOn });
    const checkIcon = classNames(icons, { "opacity-0 ease-out duration-100": !isOn }, { "opacity-100 ease-in duration-200": isOn });

    return (
        <button name="autopay-toggle" type="button" className={buttonState} role="switch" aria-checked="false" onClick={onClick} disabled={!enabled}>
            <span className="sr-only">Auto-enroll</span>
            <span className={outerIcon}>
                <span className={xIcon} aria-hidden="true">
                    <svg className="h-4 w-4 text-gray-500" fill="none" viewBox="0 0 12 12">
                        <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </span>
                <span className={checkIcon} aria-hidden="true">
                    <svg className="h-4 w-4 text-indigo-600" fill="currentColor" viewBox="0 0 12 12">
                        <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                    </svg>
                </span>
            </span>
        </button>
    );
};

Toggle.propTypes = {
    onClick: PropTypes.func.isRequired,
    isOn: PropTypes.bool.isRequired,
    enabled: PropTypes.bool
};

export default Toggle;